module.exports = __webpack_public_path__ + "img/folder-3-fill.ad10d7db.svg";